<template>
  <div class="logo" :class="classes">
    <span class="logo__main">Sneakbox</span>
    <span class="logo__sub">bêta</span>
  </div>
</template>

<script>
export default {
  name: "Logo",
  props: {
    color: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        "--color": this.color
      };
    }
  }
};
</script>

<style lang="scss">
.logo {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  &__main {
    display: inline-block;
    font-family: get($font-family, "secondary");
    font-size: 3rem;
    vertical-align: middle;
    margin-right: 1rem;
  }

  &.--color {
    > .logo__main {
      background: get($theme, "gradient-1");
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  &__sub {
    display: inline-block;
    vertical-align: middle;
    padding: 0.2rem 0.5rem;
    font-family: get($font-family, "primary");
    font-size: 1.4rem;
    font-style: italic;
    color: get($theme, "primary");
    background: #eeeeee;
    border-radius: get($radius, "arrounded");
  }
}
</style>
